/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useEffect,useCallback,useContext ,useState} from "react"
import { useDispatch,useSelector } from 'react-redux'
import { Link, useLocation,useSearchParams} from 'react-router-dom'
import TopHeader from '../../../components/TopHeader'
import TopBar from '../../../components/TopBar'
import Table from './Components'
import GlobalContext from '../../../components/Context/GloablContext'
import Pagination from '../../../components/Pagination'
import Debounce from '../../../CommonMethods/Debounce'
import Limit from '../../../components/Limit'
import CustomOverLay from '../../../components/CustomOverLay'
import { handleAddFilterValues, handleIsViewScreen, resetFilterState } from '../../../redux/systemConfigSlice'
import moment from 'moment'
import { useExportOrgUsersActivityMutation, useGetOrganizationActivityHistoryQuery } from '../../../features/organizationSlice'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen'
import HelpGuideModal from '../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'


export default function ManageOrganizationActivityHistory() {

    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const [limit,setLimit]=useState("15")
    const [exportActivityHistory]=useExportOrgUsersActivityMutation()
    const dispatch=useDispatch()
    const viewId=useSelector((state)=>state?.systemConfigData?.viewToUser)
    const [skip,setSkip]=useState(true)
    const location=useLocation()
    const [listingState] = useState(() => Array.isArray(location.state) ? (location.state[2] ?? '') : '')
    const [searchParams, setSearchParams] = useSearchParams({});
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const {data,isFetching,isLoading,isError,status,isSuccess}=useGetOrganizationActivityHistoryQuery(searchParams?.toString(),{skip:skip,refetchOnMountOrArgChange: true})
    const initialState={
        "filter_start_date":'',
        "filter_end_date":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)

    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    useEffect(() => {
        if(Array.isArray(location.state) && location.state.length>=2){
            dispatch(handleIsViewScreen([location?.state?.[1]]))
        }

        const params = Object.fromEntries(searchParams)
        let changed = false
        if(!params.limit){ params.limit = '15'; changed = true }
        if(!params.page_number){ params.page_number = '1'; changed = true }
        if(!params.filter){ params.filter = 'true'; changed = true }
        if(!params.target_organization && location.state !== null){
            params.target_organization = location.state?.[0]; changed = true
        }
        if(changed) setSearchParams(params, { replace: true })

    }, [location]);
    useEffect(()=>{
        
        if(searchParams.size>=4 ){
            setSkip(false)
        }
       
        else{
            setSkip(true)
        }
        if(searchParams.get("start_date")===null&&searchParams.get("end_date")===null){
            dispatch(resetFilterState())
        }
    },[searchParams])

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-org-view-activity-logs');
        } else {
            setQueryParamsadmin('type=admin-org-view-activity-logs');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);


    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
 
    const handleApplyFilter=(type)=>{
        let params = Object.fromEntries(searchParams);
        const start_date=moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date=moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date":filterValues.filter_start_date,
            "filter_end_date":filterValues.filter_end_date,

        }))
        if(type){
            params.page_number=1
            filterValues.filter_start_date!==""?params["start_date"]=start_date:''
            filterValues.filter_end_date!==""?params["end_date"]=end_date:''
            setSearchParams({...params})
        }
        else{
            params.start_date&&delete params.start_date
            params.end_date&&delete params.end_date
            setSearchParams({ ...params})
        }
        

        
    }

    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={"Activity Log"}/>
            <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                <div className="px-6">
                    <div className='flex items-center mb-3.5'>
                        <Link to="/manage-organizations" state={listingState}>
                            <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                        {viewId!==""&&<>
                            <Link to={`/manage-organizations/${viewId}`} state={listingState}>
                                <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                            </Link>
                            <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        </>} 
                        <h1 className="text-sm font-normal text-[#008586]">Activity Log</h1>
                        {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }
                    </div>
                    <TopBar 
                        path={(data?.data?.length===0 ||data===undefined) ? "/manage-organizations/activity_history" : `/manage-organizations/${viewId}`}
                        pathPlaceholder={((data?.data?.length===0 ||data===undefined)&&(searchParams.get("start_date")!==null||searchParams.get("end_date")!==null)) ? 'Go back to Activity Log' : 'Go back to View Organization'}
                        ApplyFilter={(searchParams.get("start_date")===null&&searchParams.get("end_date")===null&&(data?.data?.length===0 || data===undefined)) ? false : true}
                        handleApplyFilter={handleApplyFilter}
                        data={data}
                        exportCols={['Username','Time Stamp','Action Performed','Field','Old Value','Sub Division ID','New Value','Comments']}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        isFilterOrganization={true}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        initialState={initialState}
                        isExport={true}
                        username={searchParams.get("target_organization")}
                        exportOrgUsers={exportActivityHistory}
                        isIdexport={true}
                        orgActivityExport={true}
                        viewExportHistory={`/manage-organizations/activity_history/export-history`}
                        pathState={listingState}
                    />
                </div>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Activity Logs..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay1':'overlay-list1'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>   
                    <div className="px-6">
                        <Table
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={data}
                            handleSearchParams={handleSearchParams}
                        />
                    </div>
                    {data?.total_count>=15&&<div className="w-[98%] px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC]">
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}
                                isColumnSelect={isColumnSelect}
                            />
                        
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </>:<>
                    {data?.data?.length===0 && (searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                        <SearchEmptyScreen text={"That filter combination has no results.Please find different criteria"} setSkip={setSkip}/>
                        :
                        status==="rejected"&&<SearchEmptyScreen text={"No data found"} />
                    }
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }

            </div>
        </div>
    )
}
